import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/blog.css";

const BlogCard = ({ image, link, title, author, description, index }) => {
  console.warn(index);
  return (
  
    <Card className="border boxshadow text-white position-relative overlay-card">
      <img src={image} fluid alt={index} style={{
  width: "100%",
  height: "400px",
  objectFit: "cover"}} {...(image != "/images/Email_accounts.webp" ? { loading: "lazy" } : {})} />
      
      {/* Dark Overlay for Better Readability */}
      <div className="overlay"></div>

      {/* Content */}
      <Card.Body className="position-absolute overlay-content">
        <h5 className="head-color mt-3">
          <Link to={link} className="text-decoration-none divanc">{title}</Link>
        </h5>
        <p className="text-light">Published By: <strong>{author}</strong></p>
        <p className="paragr mt-4 divpar">{description}</p>
      </Card.Body>
    </Card>

  );
};

export default BlogCard;
